import React from "react";
import ProcessCard from "../components/ConfirmBid/ProcessCard";

export default function ConfirmBid() {
  return (
    <div className="auction-page container">
      <div className="title-and-pagination">
        <h1>Confirm Bid</h1>
      </div>
      <div className="auction-info">
        <ProcessCard />
      </div>
      <p className="understanding">
        We ask for your understanding as there are cases where the ocean freight
        is modified by the shipping companies without any notification.
        <br />
        container shipping fee is a reference price based on one 40 foot HC
        container.
        <br />
        It's assumed that other vehicles will be loaded into the same container.
        <br />
        The actual expense will depend on the amount of vehicles and container
        size.
        <br />
      </p>
      <button className="terms-btn">Change Trade Term</button>
    </div>
  );
}
